import React, { useEffect, useContext, useRef } from "react";
import { getEventsListRequest } from "../Redux/API";
import { useLocation } from 'react-router-dom';
import { AppContext } from "../Redux/ContextProvider";
import { Col } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import EventsDisplay from "./EventsDisplay";

function AllEvents() {
  const { appState, dispatch } = useContext(AppContext);
  const myRef = useRef(null);
  const { eventsListInfo, eventsListLoader } = appState;
  const location = useLocation();
  const isHomePage = ["/", "/home", "/*"].includes(location.pathname);
  const pageTitle = location.pathname === "/events" ? "Events" : "All Events";

  // console.log(eventsListInfo);

  useEffect(() => {
    let data = {
      ClientId: 48,
      timezone: "asia/kolkata",
    };
    getEventsListRequest(appState, dispatch, data);
  }, []);



  return (
    <>
      {eventsListLoader ? (
        <div className="home-spinner">
          <ClipLoader color={"#2A5350"} loading={true} size={60} />
        </div>
      ) : (
        <>
          {!isHomePage &&
            <Breadcrumb
              pageName={pageTitle}
              pageTitle={pageTitle}
              id=""
              image=""
              myRef={myRef}
            />
          }
          <div ref={myRef}>
            <EventsDisplay data={eventsListInfo.data} />
          </div>
        </>
      )}
    </>
  );
}

export default AllEvents;
